import { useCallback } from "react";
import { useSelector } from "react-redux";
import { getQueryData } from "src/helpers/helpers";
import useFetchAsync from "src/hooks/useFetchAsync";
import { deleteReq, useGet, usePatch, usePost } from "src/http-clients/clients";
import { getActiveStoreId } from "src/redux/selectors/app";

export const useCreateEnquiry = () => {
  const activeStore = useSelector(getActiveStoreId);
  return usePost(`/users/${activeStore}/enquiry/create`);
};

export const useGetEnquiries = ({
  length,
  page,
  search,
}: {
  length: number;
  page: number;
  search?: string;
}) => {
  const activeStore = useSelector(getActiveStoreId);
  const offset = page === 1 ? 0 : (page - 1) * length;
  const queryData = getQueryData({ length, offset, search });
  const data = useGet(`/users/${activeStore}/enquiry/list${queryData}`);
  return data;
};

export const useGetEnquiryData = (enquiryId: number) => {
  const activeStore = useSelector(getActiveStoreId);
  return useGet(
    enquiryId ? `/users/${activeStore}/enquiry/${enquiryId}` : null
  );
};

export const useUpdateEnquiry = (enquiryId: number) => {
  const activeStore = useSelector(getActiveStoreId);
  return usePatch(`/users/${activeStore}/enquiry/${enquiryId}`);
};

export const useDeleteEnquiry = () => {
  const activeStore = useSelector(getActiveStoreId);
  const deleteData = useCallback(
    (enquiryId: number) => {
      return deleteReq(`/users/${activeStore}/enquiry/${enquiryId}`);
    },
    [activeStore]
  );
  return useFetchAsync(deleteData);
};
